import * as React from "react";

import { cn } from "@/lib/utils";
import { ErrorLabel } from "@ui/internal/components/label";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string | boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label = "", error = false, ...props }, ref) => {
    return (
      <div className="flex relative z-0 flex-col gap-1 w-full">
        <div className="bg-white">
          <textarea
            className={cn(
              "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-[#A7A5A6] selection:bg-primary selection:text-primary-foreground focus-visible:border-[#1A926C] focus-visible:ring-[#1A926C]/10 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
              className
            )}
            ref={ref}
            {...props}
          />
        </div>
        {error && typeof error === "string" && <ErrorLabel message={error} />}
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
